export const NavLinks = [
  {
    path: '/dashboard',
    label: 'Dashboard',
    icon: ['fas','home']
  },
  {
    path: '/log',
    label: 'Log',
    icon: ['fas', 'square-poll-horizontal']
  },
  {
    path: '/leaderboard',
    label: 'Leaderboard',
    icon: ['fas', 'trophy']
  },
  {
    path: '/statistics',
    label: 'Statistics',
    icon: ['fas', 'chart-simple']
  }
]
